import { Flex, Title } from "@mantine/core";
import { CardBoxShadow, IconColor } from "../../../../components";
import { IColor } from "../../../../utils/selectColors";

interface IProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  disabled?: boolean;
  maxWidth?: string;
  flex?: number;
}

export default function ParameterCard({
  children,
  icon,
  title,
  disabled = false,
  maxWidth = "600px",
  flex = 1,
}: IProps) {
  return (
    <CardBoxShadow maxWidth={maxWidth} flex={flex} disabled={disabled}>
      <Flex
        w="100%"
        h="100%"
        justify="space-between"
        direction={"row"}
        p={"16px"}
        gap={"16px"}
      >
        <IconColor size="44px" colorIcon={IColor.blue}>
          {icon}
        </IconColor>
        <Flex
          justify="space-between"
          direction="column"
          h="100%"
          w="100%"
          gap="4px"
          color="basic.4"
        >
          <Title
            fw={700}
            size={16}
            lh="155%"
            color="basic.5"
            style={{
              width: "fit-content",
              wordBreak: "break-word",
            }}
          >
            {title}
          </Title>

          {children}
        </Flex>
      </Flex>
    </CardBoxShadow>
  );
}
